

























import Vue, { PropType } from 'vue'
import { confirmTopUp } from '~/api/Topup/topup.api'
import CreateDialog from '~/components/CreateDialog.vue'
import IconButton from '~/components/IconButton.vue'
import { VueForm } from '~/utils/interfaces'
import { GetTopUpDTO, TopUpStatus } from '~/utils/interfaces/topup.interface'

export default Vue.extend({
  components: { IconButton, CreateDialog },
  props: {
    item: {
      type: Object as PropType<GetTopUpDTO>,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      model: false,
      status: 'Success' as TopUpStatus,
      statuses: ['Success', 'Failed'].map(i => ({
        text: this.$t(i),
        value: i,
      })),
      files: [] as File[],
    }
  },
  methods: {
    async onSuccess() {
      if (!(this.$refs.form as VueForm).validate()) return
      this.loading = true
      try {
        await confirmTopUp(this.item.uuid, this.status, this.files)
        this.item.status = this.status
        this.$emit('refresh')
        this.model = false
      } finally {
        this.loading = false
      }
    },
  },
})
